export class ImageHelper {
	/*
	 * Returns exif orientation
	 */
	public getOrientation(file): Promise<number> {
		return new Promise((resolve) => {
			var reader = new FileReader();
			// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
			reader.onload = (e: any) => {
				var view = new DataView(e.target.result);
				if (view.getUint16(0, false) != 0xffd8) return resolve(-2);
				var length = view.byteLength,
					offset = 2;
				while (offset < length) {
					var marker = view.getUint16(offset, false);
					offset += 2;
					if (marker == 0xffe1) {
						if (view.getUint32((offset += 2), false) != 0x45786966) return resolve(-1);
						var little = view.getUint16((offset += 6), false) == 0x4949;
						offset += view.getUint32(offset + 4, little);
						var tags = view.getUint16(offset, little);
						offset += 2;
						for (var i = 0; i < tags; i++)
							if (view.getUint16(offset + i * 12, little) == 0x0112) return resolve(view.getUint16(offset + i * 12 + 8, little));
					} else if ((marker & 0xff00) != 0xff00) break;
					else offset += view.getUint16(offset, false);
				}
				return resolve(-1);
			};
			reader.readAsArrayBuffer(file);
		});
	}
}
